// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
var hasFieldRecord = function (dictIsSymbol) {
    return function (dictCons) {
        return {
            getField: function (label) {
                return $foreign.unsafeGet(Data_Symbol.reflectSymbol(dictIsSymbol)(label));
            }
        };
    };
};
var getField = function (dict) {
    return dict.getField;
};
export {
    getField,
    hasFieldRecord
};
//# sourceMappingURL=index.js.map
